import React, { useMemo } from 'react'

import { useGetPageInfo } from 'hooks/useGetPageInfo'
import { usePageConfig } from 'hooks/usePageConfig'

import { StyledProgressBar as S } from './LinearProgressBar.styles'

export const ProgressBar: React.FC = () => {
  const { currentPageId, hasProgressbar, pagesWithProgressBar } =
    useGetPageInfo()
  const { hasHeaderOffset, pageBackground } = usePageConfig()

  const currentPageIndex = useMemo(() => {
    return (
      pagesWithProgressBar.findIndex((step) => step.id === currentPageId) + 1
    )
  }, [currentPageId, pagesWithProgressBar])

  return !hasProgressbar ? null : (
    <S.Wrapper $hasHeaderOffset={hasHeaderOffset} $background={pageBackground}>
      <S.StepBlock>
        <S.StepBlockProgress
          data-active={currentPageIndex > 1}
          value={currentPageIndex}
          max={pagesWithProgressBar.length}
        />
      </S.StepBlock>
    </S.Wrapper>
  )
}
